var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 20.6781V17.8282H19.7531V20.6781H0.890625ZM4.66312 13.4709H5.82932L13.6573 5.60044L13.0642 4.99389L12.4766 4.41111L4.66312 12.2962V13.4709ZM3.24846 14.8959V11.6897L13.8205 1.05508C13.9572 0.917453 14.1122 0.813324 14.2857 0.742691C14.4592 0.672042 14.6398 0.636719 14.8273 0.636719C15.0148 0.636719 15.1965 0.672042 15.3723 0.742691C15.5481 0.813324 15.7091 0.92233 15.8555 1.06971L16.989 2.22615C17.1353 2.36377 17.2411 2.52138 17.3064 2.69896C17.3717 2.87657 17.4043 3.06009 17.4043 3.24952C17.4043 3.42712 17.3712 3.60379 17.305 3.77952C17.2388 3.95526 17.1335 4.11585 16.989 4.26129L6.43145 14.8959H3.24846ZM13.6573 5.60044L13.0642 4.99389L12.4766 4.41111L13.6573 5.60044Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/editBlack.6aee78c8151b5a8f3fea139af9680b68.svg";
export { ForwardRef as ReactComponent };